<template>
  <div>
    <!-- select 2 demo -->

    <div>
      <!-- Table Top -->
      <div>
        <!-- SideBar For Fee -->
        <b-sidebar
          id="sidebar-Fee"
          bg-variant="white"
          v-model="visibility1"
          sidebar-class="sidebar-lg"
          right
          no-header
          backdrop
          shadow
        >
          <div
            class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
          >
            <h5 class="mb-0">
              {{ $t(sidebarTitle) }}
            </h5>
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="hideDepSideBar()"
            />
          </div>
          <b-form class="p-2" @submit.prevent>
            <b-row class="mt-1">
              <b-col md="12">
                <b-form-group
                  :label="$t('Fee amount') + ' *'"
                  :invalid-feedback="$t('amount is required')"
                  ref="updatedamount"
                >
                  <b-form-input
                    ref="updatedamount"
                    type="number"
                    :placeholder="$t('Enter fee amount')"
                    v-model="myAmount"
                    @change="CheckUpdatedAmount()"
                  />
                </b-form-group>
              </b-col>

              <!-- <b-col md="12">
                <b-form-group
                  label="Classes"
                  invalid-feedback="classes  is required."
                  ref="class"
                >
                  <v-select
                    ref="class"
                    multiple
                    :closeOnSelect="false"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="classID"
                    :options="classesOptions"
                    label="name"
                    :reduce="(option) => option.id"
                    placeholder="select classes"
                    @input="setClasses()"
                  />
                </b-form-group>
              </b-col> -->

              <b-col md="12">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="success"
                  @click="AmountUpdate()"
                  :disabled="request"
                  block
                >
                  <b-spinner v-if="request" small type="grow" />
                  <span v-else> {{ $t(sidebarButton) }} </span>
                </b-button>
              </b-col>
            </b-row>
          </b-form>
          <sidebar-content />
        </b-sidebar>

        <!-- SideBar For Classes -->

        <b-sidebar
          id="sidebar-right"
          ref="mySidebar"
          bg-variant="white"
          v-model="visibility"
          sidebar-class="sidebar-lg"
          right
          no-header
          backdrop
          shadow
        >
          <div
            class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
          >
            <h5 class="mb-0">
              {{ $t(sidebarTitle) }}
            </h5>
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="hideSideBar()"
            />
          </div>
          <b-form class="p-2 pr-3" @submit.prevent>
            <b-row class="mt-1">
              <b-col md="12">
                <b-form-group
                  :label="$t('Fee Title') + ' *'"
                  :invalid-feedback="$t('Fee title is required')"
                  ref="title"
                >
                  <b-form-input
                    id="mc-first-name"
                    :placeholder="$t('Enter fee title')"
                    v-validate="'required'"
                    name="classField"
                    ref="title"
                    v-model="myObj.feeType"
                    @focusout="CheckTitle()"
                  />
                </b-form-group>
              </b-col>

              <b-col md="12" v-if="!amountField">
                <b-form-group
                  :label="$t('Fee amount') + ' *'"
                  :invalid-feedback="$t('amount is required')"
                  ref="amount"
                >
                  <b-form-input
                    ref="amount"
                    type="number"
                    :placeholder="$t('Enter fee amount')"
                    v-model="mydefaultAmount"
                    @change="CheckAmount()"
                    :disabled="amountField"
                  />
                  <p v-if="amountField" style="margin-top: 5px; color: gray">
                    {{ $t("Amount can be change from grid") }}
                  </p>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  :label="$t('Recurrence') + ' *'"
                  :invalid-feedback="$t('recurrence is required')"
                  ref="recurrence"
                >
                  <v-select
                    ref="recurrence"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="feeTypeOptions"
                    v-model="myObj.recurrence"
                    :reduce="(op) => op.value"
                    label="text"
                    :placeholder="$t('Add recurrence')"
                    @change="CheckRecurrence()"
                  />
                </b-form-group>
              </b-col>

              <div
                v-if="subObj && subObj.valueBool"
                v-for="(item, ind) in subCategories"
                :key="ind"
                class="d-flex align-items-center flex-wrap mt-1"
              >
                <b-col md="5" class="pr-0">
                  <b-form-group
                    :label="$t('Title')"
                    :invalid-feedback="$t('Title is required')"
                    ref="sub_title"
                  >
                    <b-form-input
                      ref="sub_title"
                      :placeholder="$t('Enter title here')"
                      v-model="item.feeType"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3" class="pr-0">
                  <b-form-group
                    :label="$t('Amount')"
                    :invalid-feedback="$t('Amount is required')"
                    ref="sub_amount"
                  >
                    <b-form-input
                      type="number"
                      :placeholder="$t('amount here')"
                      ref="sub_amount"
                      v-model="item.defaultAmount"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3" class="pr-0">
                  <b-form-group
                    :label="$t('Late Fee')"
                    :invalid-feedback="$t('Late Fee is required')"
                    ref="sub_late"
                  >
                    <b-form-input
                      type="number"
                      :placeholder="$t('amount here')"
                      ref="sub_late"
                      v-model="item.lateFee"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="1" class="pr-0">
                  <b-button
                    v-if="ind == subCategories.length - 1"
                    @click="AddDesc()"
                    variant="primary"
                    class="btn-icon rounded-circle"
                  >
                    <feather-icon icon="PlusIcon" />
                  </b-button>
                  <b-button
                    v-if="subCategories.length > 1"
                    @click="removeDesc(item, ind)"
                    variant="outline-danger"
                    class="btn-icon rounded-circle mt-50"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                </b-col>
              </div>

              <b-col md="12" class="mt-1">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="success"
                  @click="AddNew()"
                  :disabled="request"
                  block
                >
                  <!-- @click="Add()" -->
                  <b-spinner v-if="request" small type="grow" />
                  <span v-if="request == false"> {{ $t(sidebarButton) }} </span>
                </b-button>
              </b-col>
              <!-- {{ mydefaultAmount }} {{ myObj.defaultAmount }} -->
            </b-row>
          </b-form>
          <sidebar-content />
        </b-sidebar>

        <!-- fee increment -->
        <b-modal
          id="modal-inc"
          cancel-variant="outline-secondary"
          hide-footer
          centered
          :title="$t('Fee Increment') + getFeeType()"
          no-close-on-backdrop
        >
          <b-row>
            <b-col md="12">
              <b-form-group
                :label="$t('Classes')"
                :invalid-feedback="$t('classes is required')"
                ref="class"
              >
                <v-select
                  ref="class"
                  multiple
                  :closeOnSelect="false"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  v-model="classID"
                  :options="classesOptions"
                  label="name"
                  :reduce="(option) => option.id"
                  :placeholder="$t('select classes')"
                  @input="setClasses()"
                />
              </b-form-group>
            </b-col>
            <!-- <b-col md="12">
              <b-form-group
                :label="$t('Increment By')"
                :invalid-feedback="$t('Increment By is required')"
                ref="incBy"
              >
                <v-select
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  v-model="incObj.incrementBy"
                  :options="incOptions"
                  label="text"
                  :reduce="(option) => option.value"
                  :placeholder="$t('select')"
                  :clearable="false"
                  @input="checkValue()"
                />
              </b-form-group>
            </b-col> -->
            <b-col md="12">
              <b-form-group
                :label="$t(incObj.incrementBy)"
                :invalid-feedback="$t('Invalid value entered')"
                ref="incVal"
                label-class="text-capitalize"
              >
                <b-form-input
                  type="number"
                  :placeholder="$t('amount here')"
                  ref="incVal"
                  v-model="incObj.value"
                  @input="checkValue()"
                />
              </b-form-group>
            </b-col>
            <b-col md="12" class="text-right">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                @click="applyInc()"
                :disabled="applying"
              >
                <b-spinner v-if="applying" small type="grow" />
                <span v-else>{{ $t("Apply") }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-modal>

        <!-- fee sync monthly fees -->
        <b-modal
          id="modal-sync"
          cancel-variant="outline-secondary"
          hide-footer
          centered
          :title="$t('Sync Monthly Fees')"
          no-close-on-backdrop
        >
          <b-row>
            <b-col md="12">
              <b-form-group
                :label="$t('Class')"
                :invalid-feedback="$t('Class is required')"
                ref="sync_class"
              >
                <v-select
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  v-model="syncClass"
                  :options="classesOptions.filter((item) => item.id != 0)"
                  label="name"
                  :reduce="(option) => option.id"
                  :clearable="false"
                  :placeholder="$t('select class')"
                />
              </b-form-group>
            </b-col>

            <b-col md="12" class="text-right">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                @click="syncFee()"
                :disabled="syncing"
              >
                <b-spinner v-if="syncing" small type="grow" />
                <span v-else>Sync</span>
              </b-button>
            </b-col>
          </b-row>
        </b-modal>

        <!-- Admission Fee IDs Modal -->
        <!-- Admission Fee IDs Modal -->
        <b-modal
          id="modal-admission-fee"
          hide-footer
          centered
          no-close-on-backdrop
          size="md"
          header-class="border-bottom-0 pb-0"
          @hidden="resetAdmissionModal"
        >
          <template #modal-title>
            <div class="d-flex align-items-center">
              <feather-icon
                icon="SettingsIcon"
                size="20"
                class="text-primary mr-50"
              />
              <span class="font-weight-bolder">{{ $t("Fee Settings") }}</span>
            </div>
          </template>

          <div v-if="!showResult">
            <b-form-group
              :label="$t('Select Campuses')"
              label-class="font-weight-bolder text-dark mb-0"
            >
              <v-select
                v-model="campusIDs"
                multiple
                :options="campusOptions"
                label="name"
                :reduce="(option) => option.id"
                :placeholder="$t('Select campuses')"
                class="mt-50"
                @input="setCampuses()"
              />
            </b-form-group>

            <b-form-group
              :label="$t('Select Fee Types')"
              label-class="font-weight-bolder text-dark mb-0"
            >
              <v-select
                v-model="admissionFeeIDs"
                multiple
                :options="items"
                label="feeType"
                :reduce="(option) => option.feeType"
                :placeholder="$t('Select fees')"
                class="mt-50"
              />
            </b-form-group>

            <div class="d-flex justify-content-end mt-1">
              <b-button
                variant="outline-secondary"
                size="sm"
                @click="$bvModal.hide('modal-admission-fee')"
                class="mr-1"
                :disabled="updatingAdmission"
              >
                Cancel
              </b-button>
              <b-button
                variant="primary"
                size="sm"
                @click="updateAdmissionFeeIDs()"
                :disabled="updatingAdmission"
                class="px-2"
              >
                <b-spinner v-if="updatingAdmission" small class="mr-50" />
                {{ updatingAdmission ? $t("Saving...") : $t("Save Settings") }}
              </b-button>
            </div>
          </div>

          <div v-else class="text-center py-1">
            <feather-icon
              icon="CheckCircleIcon"
              size="40"
              class="text-success mb-1"
            />
            <h4 class="font-weight-bolder mb-1">{{ resultMessage }}</h4>

            <div
              v-if="updateResult && updateResult.length"
              class="text-left mb-1 px-1 result-scroll-area"
            >
              <div
                v-for="(res, index) in updateResult"
                :key="index"
                class="mb-1 p-1 border rounded bg-light shadow-sm"
              >
                <div
                  class="d-flex justify-content-between align-items-center mb-50"
                >
                  <h6 class="font-weight-bolder mb-0 text-primary">
                    {{ res.campusBranch }}
                  </h6>
                </div>

                <div
                  v-if="res.message"
                  class="small text-muted mb-50 font-italic"
                >
                  <feather-icon icon="InfoIcon" size="12" class="mr-25" />{{
                    res.message
                  }}
                </div>

                <div
                  v-if="res.addedFeeTypes && res.addedFeeTypes.length"
                  class="mt-50"
                >
                  <p class="small font-weight-bold mb-25 text-success">
                    Newly Added:
                  </p>
                  <b-badge
                    v-for="fee in res.addedFeeTypes"
                    :key="fee"
                    variant="light-success"
                    class="mr-25 mb-25"
                  >
                    {{ fee }}
                  </b-badge>
                </div>

                <div
                  v-if="res.skippedFeeTypes && res.skippedFeeTypes.length"
                  class="mt-50"
                >
                  <p class="small font-weight-bold mb-25 text-secondary">
                    Skipped:
                  </p>
                  <b-badge
                    v-for="fee in res.skippedFeeTypes"
                    :key="fee"
                    variant="light-secondary"
                    class="mr-25 mb-25"
                  >
                    {{ fee }}
                  </b-badge>
                </div>
              </div>
            </div>

            <b-button
              variant="primary"
              size="sm"
              @click="
                resetAdmissionModal();
                $bvModal.hide('modal-admission-fee');
              "
              class="px-3"
            >
              Close
            </b-button>
          </div>
        </b-modal>

        <b-card>
          <b-row align-h="end" class="text-right">
            <b-col class="mt-xl-0 mt-lg-0 mt-md-0 mt-sm-1 mt-1" md="10">
              <!-- :class="{ 'my-collapsing adjust': !showAll }" -->
              <b-dropdown
                v-for="(d, ind) in this.items"
                :key="ind"
                class="mx-25 mb-25"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                split
                :variant="current == d.id ? 'primary' : 'outline-primary'"
                :text="d.feeType"
                right
                @click="LoadGrid(d.id)"
              >
                <b-dropdown-item v-if="rights.edit" @click="EditFeeNew(d.id)">
                  <!-- @click="EditFee(d.id)" -->
                  {{ $t("Edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="rights.delete"
                  @click="DeleteFeeNew(d.id)"
                >
                  <!-- @click="DeleteFee(d.id)" -->
                  {{ $t("Delete") }}
                </b-dropdown-item>

                <b-dropdown-divider />
              </b-dropdown>
              <!-- </div> -->
            </b-col>
            <b-col
              v-if="rights.add"
              class="mt-xl-0 mt-lg-0 mt-md-0 mt-sm-1 mt-1 mr-50"
              cols="*"
            >
              <b-button
                @click="AddOpen()"
                style=""
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-icon rounded-circle mr-50"
                v-b-tooltip.hover.top
                :title="$t('Add Fee')"
              >
                <feather-icon size="18" icon="PlusIcon" />
              </b-button>

              <b-button
                @click="loadMissing()"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-icon rounded-circle mr-50"
                v-b-tooltip.hover.top
                :title="$t('Sync Data')"
                :disabled="dataLoading"
              >
                <feather-icon size="18" icon="RefreshCwIcon" />
              </b-button>

              <b-button
                @click="openInc()"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-icon rounded-circle"
                v-b-tooltip.hover.top
                :title="$t('Fee Increment')"
              >
                <feather-icon size="18" icon="TrendingUpIcon" />
              </b-button>

              <b-button
                v-if="
                  feesTypeSetting &&
                  feesTypeSetting.value === 'fees_type_setting'
                "
                @click="openAdmissionModal()"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-icon rounded-circle ml-50"
                v-b-tooltip.hover.top
                :title="$t('Fee Settings')"
                :disabled="updatingAdmission"
              >
                <b-spinner v-if="updatingAdmission" small />
                <feather-icon v-else size="18" icon="SettingsIcon" />
              </b-button>

              <!-- <b-button
                @click="showAll = !showAll"
                style=""
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                class="btn-icon rounded-circle"
              >
                <feather-icon
                  v-if="!showAll"
                  class="cursor-pointer"
                  size="20"
                  icon="ArrowDownIcon"
                />
                <feather-icon
                  v-else
                  class="cursor-pointer"
                  icon="ArrowUpIcon"
                  size="20"
                />
              </b-button> -->
            </b-col>
          </b-row>
          <b-row class="mt-1">
            <b-col
              class="d-flex align-items-center justify-content-start"
              xl="12"
              lg="12"
              md="12"
              sm="12"
              cols="12"
            >
              <b-form-group class="w-100 mb-0">
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <feather-icon icon="SearchIcon" />
                  </b-input-group-prepend>

                  <b-form-input
                    v-model="searchQuery"
                    :placeholder="$t('Search')"
                  >
                  </b-form-input>
                </b-input-group>
              </b-form-group>

              <b-button
                v-if="syncObj && (rights.add || rights.edit)"
                variant="outline-primary"
                class="btn-icon ml-50"
                v-b-tooltip.hover.top
                :title="$t('Sync Monthly Fees')"
                @click="openSync()"
              >
                <feather-icon icon="RefreshCwIcon" />
              </b-button>
            </b-col>
          </b-row>

          <b-table
            class="mt-1"
            ref="selectableTable"
            :items="filters"
            :fields="fields"
            :busy="dataLoading"
            :current-page="currentPage"
            :per-page="perPage"
            show-empty
            responsive
            hover
            :selectable="rights.edit"
            select-mode="single"
            @row-selected="EditAmount($event[0].obj)"
          >
            <template #empty="scope">
              <h3 class="mt-1 mb-1 text-center">
                {{ $t("No records found") }}
              </h3>
            </template>
            <template #table-busy>
              <div
                class="d-flex justify-content-center mb-3"
                style="margin-top: 50px"
              >
                <b-spinner
                  style="width: 3rem; height: 3rem"
                  type="grow"
                  variant="primary"
                  label="Spinning"
                ></b-spinner>
              </div>
            </template>

            <template #head()="scope">
              <div :class="scope.label == 'actions' && 'mr-5 text-center'">
                {{ $t(scope.label) }}
              </div>
            </template>

            <template #cell(cls)="data">
              <b-badge variant="light-primary">
                {{ data.item.cls }}
              </b-badge>
            </template>

            <template #cell(feeType)="data">
              <div>
                <b-badge variant="light-primary">
                  {{ data.item.feeType }}
                </b-badge>
              </div>
            </template>

            <template #cell(amount)="data">
              <b-badge
                :variant="
                  data.item.amount == 0 ? 'light-danger' : 'light-primary'
                "
              >
                {{ data.item.amount }}
              </b-badge>
            </template>

            <template #cell(actions)="data">
              <div class="text-center">
                <b-button
                  v-if="rights.edit"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  v-b-tooltip.hover.left
                  :title="$t('Edit')"
                  class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
                  @click="EditAmount(data.item.obj)"
                >
                  <feather-icon icon="EditIcon" class="" />
                </b-button>
              </div>
            </template>
          </b-table>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-center"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength, between } from "vuelidate/lib/validators";
import {
  BModal,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BMediaAside,
  BAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroup,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import store from "@/store";
import { avatarText } from "@core/utils/filter";
import flatPickr from "vue-flatpickr-component";
import { BFormSelect } from "bootstrap-vue";
//import Multiselect from "vue-multiselect";
import VueGallery from "vue-gallery";
import { forEach } from "postcss-rtl/lib/affected-props";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { TheMask } from "vue-the-mask";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    //Multiselect,
    BModal,
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    // BFormCheckbox,
    BForm,
    BSpinner,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    TheMask,
  },
  props: {},
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    let right = {};
    this.$store.state.menu.forEach((el) => {
      el.children.forEach((ch) => {
        right[ch.route] = {
          view: ch.view,
          add: ch.add,
          edit: ch.edit,
          delete: ch.delete,
        };
      });
    });
    this.$store.commit("setRights", right);

    if (!this.$store.state.rights[this.$route.name]) {
      // console.log(this.$store.state.rights[this.$route.name]);
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      this.LoadData(0);
      this.loadSettings();
      this.LoadSettingsAll();
      this.LoadClasses();
    }
  },
  computed: {
    filters: function () {
      return this.gridData.filter((pro) => {
        return pro.cls.toLowerCase().match(this.searchQuery.toLowerCase());
      });
    },
    campusOptions() {
      const branches = this.$store.state.branches.map((b) => ({
        id: b.id,
        name: b.branch,
      }));
      return [{ id: 0, name: "All Campuses" }, ...branches];
    },
  },
  data() {
    return {
      rights: {},
      showAll: false,
      myDepartments: [],
      request: false,
      visibility1: false,
      feeTypeOptions: [
        { text: "None", value: "none" },
        { text: "Default (Tuition Fees)", value: "default" },
        { text: "One Time", value: "one time" },
        { text: "Monthly", value: "monthly" },
        { text: "Yearly", value: "yearly" },
        { text: "After Due Date", value: "after due date" },
      ],
      sidebarTitle: "Add Class",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,
      visibility: false,
      logoloading: "",
      searchQuery: "",
      currentPage: 1,
      perPage: 30,
      totalRows: 0,
      fields: [
        { label: "Class", key: "cls" },
        { label: "Feetype", key: "feeType" },
        { label: "amount", key: "amount" },
        { key: "actions", label: "actions" },
      ],
      items: [],
      gridData: [],
      amountField: false,
      amountObj: {},
      myAmount: 0,
      mydefaultAmount: 0,
      selected: null,
      rangeDate: null,
      myObj: {
        id: 0,
        feeType: "",
        defaultAmount: 0,
        recurrence: "",
        campusID: this.$store.state.userData.cId,
      },
      assignedClass: null,
      classes: [],
      classesOptions: [],
      classID: [0],
      depObj: {
        id: 0,
        name: "",
        campusID: this.$store.state.userData.cId,
      },
      detailObj: {},
      timeout: 10000,
      current: 0,
      subObj: null,
      subCategories: [],
      incObj: {
        feeTypeID: 0,
        cls: [],
        incrementBy: "amount", // percentage
        value: 0,
      },
      incOptions: [
        { text: "Amount", value: "amount" },
        { text: "Percentage", value: "percentage" },
      ],
      applying: false,
      recurrObj: null,
      syncObj: null,
      syncClass: 0,
      syncing: false,
      admissionFeeIDs: [],
      campusIDs: [0],
      updatingAdmission: false,
      feesTypeSetting: null,
      updateResult: null,
      showResult: false,
      resultMessage: "",
    };
  },
  validations: {
    depObj: {
      name: {
        required,
        minLength: minLength(4),
      },
    },
    age: {
      between: between(20, 30),
    },
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    getFeeType() {
      let obj = this.items.find((el) => el.id == this.current);
      return obj ? ` for ${obj.feeType}` : "";
    },
    openSync() {
      this.syncClass = 0;
      this.$bvModal.show("modal-sync");
    },
    async syncFee() {
      const elem = this.$refs["sync_class"];
      if (this.syncClass == 0) {
        elem.state = false;
        return;
      }

      elem.state = true;
      this.syncing = true;

      var obj = {
        url:
          this.$store.state.domain +
          "Fees/SyncMonthlyFee?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&clsID=" +
          this.syncClass,
        context: this,
        message: "Monthly fees synced successfully.",
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);

      this.syncing = false;
      if (res) this.$bvModal.hide("modal-sync");
    },

    openInc() {
      this.incObj = {
        feeTypeID: this.current,
        cls: [],
        incrementBy: "amount", // percentage
        value: 0,
      };
      this.classID = [0];
      this.$bvModal.show("modal-inc");
    },
    checkValue() {
      // console.log(this.incObj.value);
      var elem = this.$refs["incVal"];
      if (this.incObj.incrementBy == "amount") {
        if (this.incObj.value <= 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else if (this.incObj.value <= 0 || this.incObj.value > 100) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async applyInc() {
      if (this.checkValue() == true) {
        this.applying = true;
        this.incObj.feeTypeID = this.current;
        this.incObj.value = parseInt(this.incObj.value);
        if (this.classID[0] == [0]) {
          this.incObj.cls = [];
        } else this.incObj.cls = this.classID;
        // console.log(this.incObj);

        let status = await this.post({
          url:
            this.$store.state.domain +
            "Fees/IncrementFee?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.incObj,
          context: this,
          token: this.$store.state.userData.token,
          message: "Increment applied successfully.",
        });
        this.applying = false;
        if (status) {
          this.$bvModal.hide("modal-inc");
          this.LoadGrid(this.current);
        }
      }
    },

    async loadMissing() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "MyClasses/LoadMissingStructure?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      console.log(res);
      this.LoadGrid(this.current);
    },

    async loadSettings() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["fee_sub_categories", "other_recurrence", "admission_fee_ids"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.subObj = res.find((el) => el.key == "fee_sub_categories");
      this.recurrObj = res.find((el) => el.key == "other_recurrence");
      const admissionFeeObj = res.find((el) => el.key === "admission_fee_ids");
      if (admissionFeeObj && admissionFeeObj.value) {
        try {
          this.admissionFeeIDs = JSON.parse(admissionFeeObj.value);
        } catch (e) {
          console.error("Failed to parse admission_fee_ids", e);
          this.admissionFeeIDs = [];
        }
      }
      if (this.recurrObj) {
        this.feeTypeOptions.splice(
          4,
          0,
          { text: "Quarterly (3 months)", value: "quarterly" },
          { text: "Semester wise (6 months)", value: "semester" }
        );
      }
      // console.log(this.subObj);
    },
    async LoadSettingsAll() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["sync_with_discount", "fees_type_setting"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.syncObj = res.find((el) => el.key == "sync_with_discount");
      this.feesTypeSetting = res.find((el) => el.key == "fees_type_setting");
    },
    AddDesc() {
      this.subCategories.push({
        id: 0,
        feeType: "",
        defaultAmount: 0,
        recurrence: "",
        campusID: this.$store.state.userData.cId,
        parentID: 0,
        lateFee: 0,
      });
      // console.log(this.subCategories);
    },
    async removeDesc(item, ind) {
      if (item.id == 0) {
        this.subCategories.splice(ind, 1);
        // console.log(this.subCategories);
      } else {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "FeeType/" +
            item.id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          grading: true,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.subCategories.splice(ind, 1);
        // console.log(this.subCategories);
      }
    },
    async EditFeeNew(id) {
      var obj = {
        url:
          this.$store.state.domain +
          "FeeType/LoadSelected?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&feeTypeID=" +
          id,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      // console.log(res);
      this.myObj = res.feeType;
      this.subCategories = res.subCategories;
      if (this.subObj && this.subObj.valueBool) {
        if (this.subCategories.length == 0) {
          this.subCategories = [
            {
              id: 0,
              feeType: "",
              defaultAmount: 0,
              recurrence: "",
              campusID: this.$store.state.userData.cId,
              parentID: 0,
              lateFee: 0,
            },
          ];
        }
      } else this.subCategories = [];
      // console.log("fee edit", this.myObj);
      this.amountField = true;
      this.mydefaultAmount = this.myObj.defaultAmount;
      this.sidebarTitle = "Edit Fee";
      this.sidebarButton = "Update";
      this.visibility = true;
      var elem = this.$refs["recurrence"];
      elem.state = undefined;
      var elem = this.$refs["title"];
      elem.state = undefined;
      var elem = this.$refs["amount"];
      elem.state = undefined;
    },

    async EditFee(id) {
      var obj = {
        url:
          this.$store.state.domain +
          "FeeType/GetSelected?id=" +
          id +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      this.myObj = await this.get(obj);
      // console.log("fee edit", this.myObj);
      this.amountField = true;
      this.mydefaultAmount = this.myObj.defaultAmount;
      this.sidebarTitle = "Edit Fee";
      this.sidebarButton = "Update";
      this.visibility = true;
      var elem = this.$refs["recurrence"];
      elem.state = undefined;
      var elem = this.$refs["title"];
      elem.state = undefined;
      var elem = this.$refs["amount"];
      elem.state = undefined;
    },

    async DeleteFee(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      // console.log(result);
      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "FeeType/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          message: "Fee removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData(0);
      }
    },

    async DeleteFeeNew(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      // console.log(result);
      if (result.isConfirmed) {
        var status = await this.post({
          url:
            this.$store.state.domain +
            "FeeType/Remove?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&feeTypeID=" +
            id +
            "&userID=" +
            this.$store.state.userData.userID,
          message: "Fee removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData(0);
      }
    },

    AddOpen() {
      this.mydefaultAmount = 0;
      this.myObj = {
        id: 0,
        feeType: "",
        defaultAmount: 0,
        recurrence: "",
        campusID: this.$store.state.userData.cId,
      };
      this.amountField = false;

      this.sidebarTitle = "Add Fee";
      this.sidebarButton = "Save";

      if (this.subObj && this.subObj.valueBool) {
        this.subCategories = [
          {
            id: 0,
            feeType: "",
            defaultAmount: 0,
            recurrence: "",
            campusID: this.$store.state.userData.cId,
            parentID: 0,
            lateFee: 0,
          },
        ];
      } else this.subCategories = [];

      this.visibility = true;
      var elem = this.$refs["recurrence"];
      elem.state = undefined;
      var elem = this.$refs["title"];
      elem.state = undefined;
      var elem = this.$refs["amount"];
      elem.state = undefined;
    },

    CheckClass() {
      console.log("class", this.assignedClass);
    },

    OpenDepartmentF() {
      this.visibility = true;
      //   this.depObj.id = 0;
      //   this.depObj.name = "";
      this.depObj.campusID = this.$store.state.userData.cId;
      this.sidebarTitle = "Add Fee";
      this.sidebarButton = "Save";
      //   var elem = this.$refs["depname"];
      //   elem.state = undefined;
    },

    EditAmount(obj) {
      // console.log("am_obj:", obj);
      this.amountObj = obj;
      this.myAmount = this.amountObj.amount;
      this.sidebarTitle = "Update Amount";
      this.sidebarButton = "Update";
      this.visibility1 = true;
      var elem = this.$refs["updatedamount"];
      elem.state = undefined;
    },

    CheckRequired(name) {
      var elem = this.$refs[name];
      if (this.myObj.name == "" || this.myObj.name > 20) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }

      // return (elem.state = this.$v.depObj.name.required);
    },

    CheckTitle() {
      var elem = this.$refs["title"];
      if (this.myObj.feeType == "" || this.myObj.feeType > 20) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckAmount() {
      if (this.amountField) {
        return true;
      } else {
        var elem = this.$refs["amount"];
        let x = parseInt(this.mydefaultAmount);
        if (isNaN(x) || x < 0) {
          return (elem.state = false);
        } else {
          this.mydefaultAmount = x;
          return (elem.state = true);
        }
      }
    },
    CheckUpdatedAmount() {
      var elem = this.$refs["updatedamount"];
      let x = parseInt(this.myAmount);
      if (isNaN(x) || x < 0) {
        return (elem.state = false);
      } else {
        this.myAmount = x;
        return (elem.state = true);
      }
    },
    CheckRecurrence() {
      var elem = this.$refs["recurrence"];
      if (this.myObj.recurrence == null || this.myObj.recurrence == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckDepartment() {
      var elem = this.$refs["department"];
      if (this.myObj.departmentID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    hideSideBar() {
      this.visibility = false;
    },
    hideDepSideBar() {
      this.visibility1 = false;
    },

    async LoadData(id) {
      var obj = {
        url:
          this.$store.state.domain +
          "FeeType?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);
      // console.log("fee data", this.items);
      if (this.items.length > 0) {
        if (id == 0) {
          let feeTypeId = this.items[0].id;
          this.LoadGrid(feeTypeId);
        } else if (id == 1) {
          let feeTypeId = this.items[this.items.length - 1].id;
          this.current = feeTypeId;
          // this.LoadGrid(feeTypeId);
        } else {
          this.LoadGrid(id);
        }
      }
    },
    async LoadGrid(id) {
      this.current = id;
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "FeeType/Load?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&feeTypeID=" +
          id,
        token: this.$store.state.userData.token,
      };
      this.gridData = await this.get(obj);
      if (this.gridData.length != 0) {
        this.totalRows = this.gridData.length;
      }
      this.dataLoading = false;
      // console.log("grid", this.gridData);
    },
    async LoadDepartments() {
      var obj = {
        url:
          this.$store.state.domain +
          "departments?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.myDepartments = await this.get(obj);
    },

    async LoadClasses() {
      var obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      //  this.items =[];
      let myitem = await this.get(obj);
      this.classes = myitem;
      this.classesOptions = [];
      this.classesOptions = this.classes.map((el) => el.cls);
      this.classesOptions.unshift({ id: 0, name: "All Classes" });
    },
    setClasses() {
      if (this.classID.length > 0 && this.classID.at(-1) == 0) {
        this.classID = [0];
      } else {
        this.classID = this.classID.filter((el) => el != 0);
      }
      // console.log(this.classID);
    },
    setCampuses() {
      if (this.campusIDs.length > 0 && this.campusIDs.at(-1) == 0) {
        this.campusIDs = [0];
      } else {
        this.campusIDs = this.campusIDs.filter((el) => el != 0);
      }
    },

    async AmountUpdate() {
      // const data = {
      //   feeAmount: this.amountObj,
      //   clsIDs: this.classID,
      // };
      // console.log(data);
      this.CheckUpdatedAmount();
      if (this.CheckUpdatedAmount() == false) {
        return this.$bvToast.toast(
          this.$t("Please enter the amount correctly."),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } else {
        this.amountObj.amount = parseInt(this.myAmount);
        // console.log(this.amountObj);
        this.request = true;
        var status = await this.put({
          url:
            this.$store.state.domain +
            "FeeAmount/" +
            this.amountObj.id +
            "?db=" +
            this.$store.state.userData.db +
            "&userID=" +
            this.$store.state.userData.userID,
          body: this.amountObj,
          message: "Amount updated successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.request = false;
        this.visibility1 = false;
        if (status) this.LoadGrid(this.amountObj.feeTypeID);
      }
    },

    async Add() {
      // console.log("obj:", this.myObj);
      // console.log("am", this.mydefaultAmount);
      this.CheckTitle();
      this.CheckAmount();
      this.CheckRecurrence();
      if (
        this.CheckTitle() == false ||
        this.CheckAmount() == false ||
        this.CheckRecurrence() == false
      ) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.myObj.defaultAmount = parseInt(this.mydefaultAmount);
        if (this.myObj.id == 0) {
          //Add
          this.request = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "FeeType/Add?db=" +
              this.$store.state.userData.db +
              "&userID=" +
              this.$store.state.userData.userID,
            body: this.myObj,
            message: "Fee added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          this.visibility = false;
          if (status) this.LoadData(1);
        } else {
          //Edit
          this.request = true;
          var status = await this.put({
            url:
              this.$store.state.domain +
              "FeeType/" +
              this.myObj.id +
              "?db=" +
              this.$store.state.userData.db +
              "&userID=" +
              this.$store.state.userData.userID,
            body: this.myObj,
            message: "Fee type updated successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          this.visibility = false;
          if (status) this.LoadData(this.myObj.id);
        }
      }
    },
    checkSubCats() {
      let state = true;

      this.subCategories = this.subCategories.filter((el) => {
        return el.feeType != "" && el.defaultAmount != 0 && el.lateFee != 0;
      });
      this.subCategories.forEach((el) => {
        // console.log(el);
        el.defaultAmount = parseInt(el.defaultAmount);
        el.lateFee = parseInt(el.lateFee);
        if (
          isNaN(el.defaultAmount) ||
          el.defaultAmount <= 0 ||
          isNaN(el.lateFee) ||
          el.lateFee < 0 ||
          el.feeType === ""
        ) {
          state = false;
        }
      });
      return state;
    },
    async AddNew() {
      // console.log("obj:", this.myObj);
      // console.log("am", this.mydefaultAmount);
      this.CheckTitle();
      this.CheckAmount();
      this.CheckRecurrence();
      if (
        this.CheckTitle() == false ||
        this.CheckAmount() == false ||
        this.CheckRecurrence() == false ||
        this.checkSubCats() == false
      ) {
        return this.$bvToast.toast(this.$t("Please fill the form correctly."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.myObj.defaultAmount = parseInt(this.mydefaultAmount);
        if (this.myObj.id == 0) {
          //Add
          this.request = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "FeeType/Save?db=" +
              this.$store.state.userData.db +
              "&userID=" +
              this.$store.state.userData.userID,
            body: {
              feeType: this.myObj,
              subCategories: this.subCategories,
            },
            message: "Fee added successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          this.visibility = false;
          this.subCategories = [];
          if (status) {
            this.LoadData(1);
            this.loadMissing();
          }
        } else {
          //Edit
          this.request = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "FeeType/Save?db=" +
              this.$store.state.userData.db +
              "&userID=" +
              this.$store.state.userData.userID,
            body: {
              feeType: this.myObj,
              subCategories: this.subCategories,
            },
            message: "Fee type updated successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          this.visibility = false;
          this.subCategories = [];
          if (status) this.LoadData(this.myObj.id);
        }
      }
    },
    openAdmissionModal() {
      this.$bvModal.show("modal-admission-fee");
    },
    async updateAdmissionFeeIDs() {
      this.updatingAdmission = true;
      try {
        const res = await this.post({
          url:
            this.$store.state.domain +
            "Settings/UpdateAdmissionFeeIDs?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: {
            feeTypeNames: this.admissionFeeIDs,
            cIDs: this.campusIDs,
            db: this.$store.state.userData.db,
          },
          context: this,
          token: this.$store.state.userData.token,
          allResponse: true,
        });

        if (res && res.status === "success") {
          this.updateResult = res.data;
          this.resultMessage =
            res.message ||
            "Admission Fee settings have been updated successfully.";
          this.showResult = true;
          this.loadSettings(); // Reload settings to keep data in sync
        } else {
          // If the post wrapper returns something else but it worked
          if (res && !res.status) {
            this.$bvModal.hide("modal-admission-fee");
            this.loadSettings();
          }
        }
      } catch (error) {
        console.error("Update Admission Fee Error:", error);
        this.$bvToast.toast(
          this.$t("Failed to update Admission Fee settings. Please try again."),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } finally {
        this.updatingAdmission = false;
      }
    },
    resetAdmissionModal() {
      this.showResult = false;
      this.updateResult = null;
      this.resultMessage = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
.my-collapsing {
  height: 55px;
  overflow: hidden;
}
.my-collapsing.adjust {
  height: 39px;
}
.my-buttons {
  position: absolute;
  top: 0px;
  right: 10px;
  cursor: pointer;
}

.update-summary {
  border-radius: 8px;
  overflow: hidden;
}
.result-scroll-area {
  max-height: 350px;
  overflow-y: auto;
  border: 1px solid #f1f1f1;
  border-radius: 4px;
}
</style>
